import { default as tippy, hideAll } from 'tippy.js';

(function () {
	tippy(`.tooltip-link`, {
		allowHTML: true,
		offset: [0, 28],
		interactive: true,
		arrow: true,
		// showOnCreate: true,
		maxWidth: window.innerWidth > 810 ? `calc(100vw - 26em - 5em)` : `none`,
		onShow(instance) {
			hideAll({
				exclude: instance,
			});
		},
	});
})();
